export default __webpack_public_path__ + "static/media/edit-job.d4cbfa63.gif";